import React from "react";
import ToolbarButtons from "../Toolbar/buttons";

class WysiwygDirectionButton extends React.Component
{
    OnClick = (e, direction) =>
    {
        const {onChangeDirection = () => {}} = this.props;
        onChangeDirection(e, direction);
    }

    render()
    {
        const {direction} = this.props;
        return (
            <ToolbarButtons
                active={[direction]}
                className="WysiwygToolbarDirection"
                buttons={{
                    column: ["MoreVertical", "Vertical Direction"],
                    row: ["MoreHorizontal", "Horizontal Direction"]
                }}
                onClick={this.OnClick}
            />
        )
    }
}

export default WysiwygDirectionButton;